// Guarda la orden de Conekta que está a medio autenticar.
//
// Hace falta porque el componente 3DS tiene dos salidas y una de ellas destruye el
// estado de la app: cuando NO corre en modo embebido hace
// `window.top.location.href = urlRedirect`, o sea navega la ventana completa hacia la
// `return_url`. Al volver, Redux arranca de cero y ya no sabemos qué orden confirmar,
// así que el id tiene que vivir fuera de Redux.
//
// `sessionStorage` y no `localStorage` a propósito: si el usuario abandona y cierra la
// pestaña, el pendiente se va con ella en vez de quedarse colgado para siempre.

const STORAGE_KEY = 'wnConektaPendingOrderId';

export const savePendingConektaOrderId = orderId => {
  if (!orderId) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, orderId);
  } catch (error) {
    // Ventana privada o almacenamiento bloqueado: el flujo embebido sigue
    // funcionando, solo se pierde el rescate por redirección.
  }
};

export const readPendingConektaOrderId = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

export const clearPendingConektaOrderId = () => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // nada que hacer
  }
};
